<script setup lang="ts">
interface Props {
    isOpen: boolean;
}
defineProps<Props>();
</script>

<template>
    <button
        class="hamburger"
        :class="{ open: isOpen }"
        :aria-expanded="isOpen"
        aria-label="Toggle navigation"
    >
        <span></span>
        <span></span>
        <span></span>
    </button>
</template>

<style scoped>
/* --Layout---------------------------------------------------- */

.hamburger {
    --width: 22px; /* total icon box width  */
    --height: 26px; /* total icon box height  */
    --stroke: 2px; /* thickness of each bar */
    --gap: 5px; /* gap between bars      */
    --duration: 0.25s; /* animation speed       */

    width: var(--width);
    height: var(--height);
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: var(--gap);
    padding: 0;
    background: transparent;
    border: none;
    cursor: pointer;
    border-radius: 1px;
}

/* Hide the default focus outline but keep keyboard focus visible */
.hamburger:focus {
    outline: none;
}
.hamburger:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 4px;
}

/* --Bars------------------------------------------------------ */

.hamburger span {
    display: block;
    width: 100%;
    height: var(--stroke);
    background-color: currentColor;
    border-radius: var(--stroke);
    transition:
        transform var(--duration) ease,
        opacity var(--duration) ease;
    transform-origin: center;
}

/* --Open → X state------------------------------------------ */

.hamburger.open span:nth-child(1) {
    transform: translateY(calc(var(--gap) + var(--stroke))) rotate(45deg);
}

.hamburger.open span:nth-child(2) {
    opacity: 0;
}

.hamburger.open span:nth-child(3) {
    transform: translateY(calc(-1 * (var(--gap) + var(--stroke)))) rotate(-45deg);
}
</style>
